"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _indexModule = _interopRequireDefault(require("./index.module.css"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _table = _interopRequireDefault(require("../../components/table"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StyleWrapper = _styledComponents.default.div`

ul{

    background-color: #054894;
    box-shadow: 1px 1px 8px #c7c7c7;
    border-radius: 10px;
    padding: 20px 20px;
    color: #fff;

}

p{
    // color:grey;
    margin-bottom:0.5rem;
}

h2{
    // color: #164686;
    margin-bottom:20px;
}


`;
const TableWrapper = _styledComponents.default.div`

.table-bordered thead td, .table-bordered thead th {
min-width: 100px !important;
vertical-align: top !important;
}
th {
   background: #1e91ce;
   font-size: 15px;
   color: #fff;
   font-weight: 500;
   border: 1px solid white;
   border-top: 0px !important;
   padding: .60rem;
 }
  td {
      padding: .75rem;
    font-size: 13px;
    background: #ececec;
    vertical-align: middle;
 }
.table-responsive > .table-bordered {
  border: 0;
  font-size: 15px;
}
.table-responsive{
    overflow-x:none;
}
@media(max-width:768px){
    .table-bordered thead td, .table-bordered thead th {
      min-width: auto !important;
      vertical-align: top !important;
      }
      .table-bordered > thead > tr > th:first-child{
        width: auto !important;
      }
      .table-responsive{
          overflow-x: auto;
      }
  }
`;
function InvestmentProperty() {
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
  }, []);
  const getSunWestSuccessYears = () => {
    //Sun West founded in 08/12/1980
    const foundedDate = new Date('1980-08-12');
    const todayDate = new Date();
    const yearDiff = todayDate.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday = todayDate.getMonth() < foundedDate.getMonth() || todayDate.getMonth() === foundedDate.getMonth() && todayDate.getDate() < foundedDate.getDate();
    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Investment Property"))), /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(StyleWrapper, null, /*#__PURE__*/_react.default.createElement("p", null, "Whether you are a first time investor financing your first investment property or a seasoned professional in real-estate investment, Sun West has both the experience and expertise to help you find the right loan. For the beginning investor, our professional mortgage consultants will discuss your investment objectives and financing requirements with you, and we will recommend to you a mortgage that best suits your goals. For the professional investor, Sun West's experience in underwriting investment loans can provide additional insights and helpful information that may be beneficial to you in making your decision while at the same time help you select alternative financing options that you may not have considered before."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "With Sun West, you are choosing the right place to help finance your investment property. We are a full-service lender with over ", getSunWestSuccessYears(), " years of experience underwriting loans for single-family, multi-family, commercial real estate, and construction, including properties for our own investment portfolios. Have the confidence you need by choosing Sun West Mortgage for your real-estate investment needs."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: _indexModule.default.headerRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.header_border
  }, " "), /*#__PURE__*/_react.default.createElement("h2", null, "Advantages of owning an investment property..."), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "The market has shown time and again that demand for rental homes will always be there. Having a rental property means you have the opportunity to generate consistent, long-term cash flow. This is especially true if you invest in a property near population centers, such as around college campuses, established business areas, or stable communities where there is always a demand to rent."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "Invest to renovate a property and increase its resale value. This option has gained popularity among investors because it has the potential to generate profit in the short term and offers a rewarding experience when you know that you have produced value for a home that you have done the research and improvement project for."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "The income you generate from either renting out or reselling your property can be used for additional future investments. Start with one investment property, and increase it to multiple investment properties."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "Added tax benefits, such as tax reduction from your mortgage interest or property tax. Please consult your tax advisor, as tax benefits may vary based on individual circumstances."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, "Invest with the goal to establish financial security for yourself, your family, or your grandchildren. If you start investing in a property early, you have the opportunity to increase savings, build your financial assets, and provide future financial stability for your family as they grow."))))));
}
var _default = exports.default = InvestmentProperty;